<mat-form-field [style.width]="'100%'">
	<mat-label *ngIf="props.label">{{ props.label }}</mat-label>
	<input matInput [matAutocomplete]="auto" [errorStateMatcher]="errorStateMatcher" [formControl]="inputFormControl" [formlyAttributes]="field"
		[required]="props.required ?? false" (blur)="onBlur()" />
	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionChanged($event.option)">
		<mat-option *ngFor="let option of filter | async" [value]="option">
			{{ option.VendorDisplay }}
		</mat-option>
	</mat-autocomplete>
	<mat-icon aria-hidden="false" aria-label="Clean" matSuffix (click)="removeVendor()">close</mat-icon>
	<mat-error>
		<formly-validation-message [field]="field"></formly-validation-message>
	</mat-error>
</mat-form-field>